import React, { useEffect, useState } from 'react';
import { Translate } from 'react-localize-redux';
import styled, { withTheme } from 'styled-components';

import Heading, { SubHeading } from '../../components/heading';
import ScriptLoader from '../../components/script-loader';

const TwitterContainer = styled.div`
  text-align: center;
`;

const Container = styled.div`
  padding: 1em;
`;

const News = ({ theme }) => {
  const [twttr, setTwttr] = useState(null);

  useEffect(() => {
    if (twttr && twttr.widgets) {
      twttr.widgets.load();
    }
  });

  return (
    <>
      <ScriptLoader
        id="twitter-wjs"
        onLoad={() => setTwttr(window.twttr)}
        src="https://platform.twitter.com/widgets.js"
      />
      <Container>
        <Heading>NEWS</Heading>
        <SubHeading>
          <Translate id="landingPage.news.subtitle" />
        </SubHeading>
        <TwitterContainer key={theme.primary}>
          <a
            className="twitter-timeline"
            data-chrome="nofooter noborders"
            data-dnt="true"
            data-lang="ja"
            data-limit="3"
            data-link-color={theme.primary}
            data-partner="tweetdeck"
            data-theme="dark"
            href="https://twitter.com/ARpuzzle_/timelines/1082901331168247808"
          >
            .
          </a>
        </TwitterContainer>
      </Container>
    </>
  );
};

export default withTheme(News);
